import { Controller, Control, FieldPath, FieldValues } from 'react-hook-form';
import { Stack, styled } from '@mui/material';
import { RadioButtonCard } from './RadioButtonCard';

interface RadioOption {
  value: string;
  label: string;
}

interface Props<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  options: RadioOption[];
}

export const RadioButtonGroup = <T extends FieldValues>({
  name,
  control,
  options,
}: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Container
          spacing={5}
          data-testid="radio-button-group"
          role="radiogroup"
        >
          {options.map((option) => (
            <RadioButtonCard
              key={option.value}
              value={option.value}
              label={option.label}
              selected={field.value === option.value}
              onChange={(value) => field.onChange(value)}
            />
          ))}
        </Container>
      )}
    />
  );
};

const Container = styled(Stack)({
  width: '100%',
});
